import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { Label } from "components/input/Label";
import ViagemTipoDespesaService from "service/viagem/ViagemTipoDespesaService";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import InputMonetario from "components/input/InputMonetario";

const viagemTipoDespesaService = new ViagemTipoDespesaService();

export default function ViagemTipoDespesaCadastro() {

    const [queryParameters] = useSearchParams();

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [viagemTipoDespesa, setViagemTipoDespesa] = useState<ViagemTipoDespesa>(new ViagemTipoDespesa());
    const [titulo, setTitulo] = useState<string>('Tipo de despesa');

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {

        if (!viagemTipoDespesa.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={viagemTipoDespesa} service={viagemTipoDespesaService} setModel={(value: ViagemTipoDespesa) => setViagemTipoDespesa(value)} novoCadastro getNewModel={() => new ViagemTipoDespesa()}
            validar={() => validar()} urlService="/viagemTipoDespesa" pathCadastro="/viagemTipoDespesa" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={viagemTipoDespesa.nome}
                        style={{ width: '30%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setViagemTipoDespesa({ ...viagemTipoDespesa, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12">Valor alerta</Label>
                <div className="col-sm-12">
                    <InputMonetario value={viagemTipoDespesa.valorAlerta || 0}
                        onChange={(e) => {
                            setViagemTipoDespesa({ ...viagemTipoDespesa, valorAlerta: e });
                        }}

                    />
                </div>
            </div>

        </BaseCadastro>
    )
}
